import React from 'react';
import {
  AlertsOutlined as Alerts,
  Applications,
  AssetsOutline as Assets,
  Component,
  ComponentInstance,
  CriticalOutline as Critical,
  EntitiesOutlined as Entities,
  FindingsOutline as Findings,
  Applications as Groups,
  IncidentsOutlined as Incidents,
  Object,
  PolicyViolationsOutlined as PolicyViolations,
  Tenant,
  Ticket,
  UserUnfilled as User,
} from '@fabric-ui/icons';

const projColorsMap = theme => ({
  default: theme.palette.colors.neutrals[550],
  // eslint-disable-next-line fabric-ui/no-color-hex
  incidents: '#9696F4',
  tickets: theme.palette.colors.primary[400],
  // eslint-disable-next-line fabric-ui/no-color-hex
  alertActors: '#B08775',
  alerts: theme.palette.colors.orange[400],
  applications: theme.palette.colors.pink[300],
  assets: theme.palette.colors.blue[500],
  componentInstances: theme.palette.colors.green[400],
  components: theme.palette.colors.positive[500],
  findings: theme.palette.colors.yellow[500],
  vulnerabilities: theme.palette.colors.negative[400],
  orgEntities: theme.palette.colors.purple[400],
  uber_policy_populations: theme.palette.colors.purple[400],
  uber_policy_violations: theme.palette.colors.negative[300],
});

export const ingressProjIcons = theme => {
  const colorsMap = projColorsMap(theme);
  return {
    alerts: { color: 'transparent', iconColor: colorsMap.alerts, icon: <Alerts /> },
    alert_actors: { color: 'transparent', iconColor: colorsMap.alertActors, icon: <Entities /> },
    applications: { color: 'transparent', iconColor: colorsMap.applications, icon: <Applications /> },
    assets: { color: 'transparent', iconColor: colorsMap.assets, icon: <Assets /> },
    components: { color: 'transparent', iconColor: colorsMap.components, icon: <Component /> },
    component_instances: { color: 'transparent', iconColor: colorsMap.componentInstances, icon: <ComponentInstance /> },
    findings: { color: 'transparent', iconColor: colorsMap.findings, icon: <Findings /> },
    org_entities: { color: 'transparent', iconColor: colorsMap.orgEntities, icon: <User /> },
    vulnerabilities: { color: 'transparent', iconColor: colorsMap.vulnerabilities, icon: <Critical /> },
    defaultIngress: { color: 'transparent', iconColor: colorsMap.default, icon: <Object /> },
    users: { color: 'transparent', iconColor: colorsMap.orgEntities, icon: <User /> },
    tenants: { color: 'transparent', iconColor: colorsMap.orgEntities, icon: <Tenant /> },
    security_groups: { color: 'transparent', iconColor: colorsMap.orgEntities, icon: <Groups /> },
  };
};

export const uberProjIcons = theme => {
  const colorsMap = projColorsMap(theme);
  return {
    default: { color: colorsMap.default, icon: <Object /> },
    incidents: { color: colorsMap.incidents, icon: <Incidents /> },
    tickets: { color: colorsMap.tickets, icon: <Ticket /> },
    uber_alert_actors: { color: colorsMap.alertActors, icon: <Entities /> },
    uber_alerts: { color: colorsMap.alerts, icon: <Alerts /> },
    uber_applications: { color: colorsMap.applications, icon: <Applications /> },
    uber_assets: { color: colorsMap.assets, icon: <Assets /> },
    uber_component_instances: { color: colorsMap.componentInstances, icon: <ComponentInstance /> },
    uber_components: { color: colorsMap.components, icon: <Component /> },
    uber_findings: { color: colorsMap.findings, icon: <Findings /> },
    uber_global_vulnerabilities: { color: colorsMap.vulnerabilities, icon: <Critical /> },
    uber_org_entities: { color: colorsMap.orgEntities, icon: <User /> },
    uber_policy_populations: { color: colorsMap.uber_policy_populations, icon: <PolicyViolations /> },
    uber_policy_violations: { color: colorsMap.uber_policy_violations, icon: <PolicyViolations /> },
    uber_users: { color: colorsMap.default, icon: <User /> },
    uber_tenants: { color: colorsMap.default, icon: <Tenant /> },
    uber_security_groups: { color: colorsMap.default, icon: <Groups /> },
  };
};
